import script from "./OnboardingAiFailedStep.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiFailedStep.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiFailedStep.vue?vue&type=style&index=0&id=f6decf56&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6decf56"]])

export default __exports__